// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__11nhj","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1pyWH","obliqueLine":"membershipbadge_obliqueLine__3lvZ9"};